import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';

const createStyles = (colors) => StyleSheet.create({
  divider: {
    height: 1,
    backgroundColor: colors.border_color_secondary,
    width: '100%',
    marginVertical: 5,
  },
});

export default function DropdownMenuItemDivider() {
  const { colors } = useTheme();
  const styles = React.useMemo(() => createStyles(colors), [colors]);

  return (
    <DropdownMenu.Item className="DropdownMenuItemDivider">    
      <View style={styles.divider} />
    </DropdownMenu.Item>
  );
}